import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Calendar from "@engineering/icons/calendar";
import { ButtonWrapper, StyledButton } from "./DatePickerButton.styles";
import { useFormattedDate } from "./useFormattedDate";
var DatePickerButton = function(param) {
    var title = param.title, from = param.from, to = param.to, size = param.size, onClick = param.onClick;
    var fromDate = useFormattedDate(from);
    var toDate = useFormattedDate(to);
    return /*#__PURE__*/ _jsxs(ButtonWrapper, {
        children: [
            /*#__PURE__*/ _jsx(StyledButton, {
                type: "button",
                id: "datepicker",
                "aria-haspopup": "true",
                title: title,
                size: size,
                onClick: onClick,
                children: fromDate && toDate && /*#__PURE__*/ _jsx("span", {
                    id: "datepickerValue",
                    children: "".concat(fromDate, " - ").concat(toDate)
                })
            }),
            /*#__PURE__*/ _jsx(Calendar, {
                id: "datepicker-cal-icon"
            })
        ]
    });
};
export { DatePickerButton };
